import { createFileRoute } from '@tanstack/react-router'
import { createStore, Provider } from 'jotai'
import z from 'zod'

import AnggotaPoktanPage from '@/components/pages/guest/_search/containers/anggota-poktan'

export const Route = createFileRoute(
  '/_guest/guest/search/farmer-poktan-members'
)({
  component: RouteComponent,
  validateSearch: z.object({
    nik: z.string().optional(),
    page: z.number().min(1).optional().default(1),
    per_page: z.number().min(10).max(100).optional().default(50)
  })
})

const store = createStore()

function RouteComponent() {
  return (
    <Provider store={store}>
      <AnggotaPoktanPage />
    </Provider>
  )
}
